import { differenceInHours } from 'date-fns';
import { MAX_LOCK_DURATION, STORY_STATUSES } from '../../../utils/appConstants/appConstants';
import { useSelector } from 'react-redux';
import { selectStory } from 'src/reducers/storiesReducer';
import { selectUser } from 'src/reducers/authReducer';
import { Story } from 'src/models/Story';
import { getBodyTextLength } from '../../../utils/AppFunctions/appFunctions';

const {
  RETURNED_FOR_REWORK
} = STORY_STATUSES;

export const useStory = (isNewStory?) => {
  const story = isNewStory
    ? {
      id: undefined,
      title: '',
      status: STORY_STATUSES.DRAFT,
      organizations: [],
      images: [],
      attachments: [],
      confidential: false,
      sPCReviewCompleted: false,
      created: '',
      modified: '',
      submitted: '',
      published: '',
      lock: undefined,
      authors: [],
      dateStart: '',
      dateEnd: '',
      body: '<p>*</p>',
      textLength: getBodyTextLength('<p>*</p>'),
      flagForReview: false,
      sensitive: false,
      sensitiveComments: '',
      approver: undefined,
      approverComments: '',
      inviter: undefined,
      notes: '',
      personTags: []
    } as Story
    : useSelector(selectStory);

  const user = useSelector(selectUser);

  const badOrMissingStory = !story || Object.keys(story).length === 0;
  const wardCouncil = story?.authors ?? [{}];
  const isLocked = story?.lock && story.lock.uuid !== user?.uuid;
  const lock = story?.lock?.date;
  const lockDuration = isLocked && lock && differenceInHours(new Date(), lock);
  const isUnlockable = lockDuration ? lockDuration > MAX_LOCK_DURATION : true;
  const inRework = story?.status === RETURNED_FOR_REWORK && (story.submitted || story.published);

  return {
    story,
    badOrMissingStory,
    wardCouncil,
    isLocked,
    lockDuration,
    isUnlockable,
    inRework
  }
}
